import useIntersectionObserver from '@/hooks/shared/useIntersectionObserver';

import { InfoItemType } from './solutionItemTypes';

type SolutionFeatureProps = {
  feature: {
    title: React.ReactNode;
    items: InfoItemType[];
  };
};

export default function SolutionFeature({ feature }: SolutionFeatureProps) {
  const container = useIntersectionObserver<HTMLDivElement>({
    selector: '[data-reveal-item]',
    staggerMs: 150,
  });

  return (
    <div ref={container}>
      <h4
        data-reveal-item
        className="intersection-reveal mb-4 text-[20px] font-bold leading-[140%] tracking-[-0.4px] text-apps-coreGray01 lg:mb-6 lg:text-[clamp(20px,2.333vw,28px)] lg:tracking-[-0.56px]"
      >
        {feature.title}
      </h4>
      <ul className="flex flex-col gap-4 lg:gap-6">
        {feature.items.map((item, index) => (
          <li
            key={index}
            data-reveal-item
            className="intersection-reveal rounded-2xl bg-apps-coreGray07 p-5 lg:rounded-[20px] lg:p-[clamp(20px,3.333vw,40px)]"
          >
            <div className="mb-2 text-[18px] font-bold not-italic leading-[120%] tracking-[-0.36px] text-apps-brandGray50 lg:text-[clamp(18px,1.833vw,22px)] lg:leading-[160%] lg:tracking-[-0.44px]">
              {item.title}
            </div>
            <div className="text-[16px] font-medium leading-[140%] tracking-[-0.32px] text-apps-brandGray200">
              {item.description}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
